import { LifestylesKeyType } from '../../keys';

const lifestylesKeys: LifestylesKeyType = {
  // add: 'Add lifestyle to library',
  addLifestyle: 'Add lifestyle',
  all: 'All lifestyles',
  associatedAssets: 'Associated assets',
  associatedScenes: 'Associated scenes',
  attach: 'Attach lifestyles',
  attachLifestyle: 'Attach lifestyle',
  attachSelected: 'Attach selected lifestyles',
  categories: {
    bedroom: 'Bedroom',
    commercialAreas: 'Commercial areas',
    dining: 'Dining',
    exteriors: 'Exteriors',
    livingApartments: 'Living apartments',
    sanitaryFacilities: 'Sanitary facilities',
    transitAreas: 'Transit areas'
  },
  category: 'Lifestyle category',
  clearLifestyleCache: 'Clear lifestyle cache',
  clearLifestylesCache: 'Clear lifestyles cache',
  companyLifestyle: 'Company lifestyle',
  deleteLifestyle: 'Delete lifestyle',
  deleteWarning:
    'Are you sure you want to delete lifestyle? This action cannot be undone.',
  download: 'Download lifestyle',
  editLifestyle: 'Edit lifestyle',
  my: 'My Lifestyles',
  name: 'Lifestyle name',
  plural: 'Lifestyles',
  projectName: 'Project name',
  search: 'Search lifestyles',
  selected: 'Selected lifestyles',
  singular: 'Lifestyle',
  threeDStock: '3D Stock Lifestyles',
  timeHours: 'Time (hours)',
  type: 'Lifestyle Type',
  viewAll: 'View all lifestyles'
};

export default lifestylesKeys;
